import type { GetToolPreferencesQuery, GetToolPreferencesQueryVariables } from 'generated/graphql';
import { createContextedQuery } from 'modules/Apollo/createContextedQuery';
import { GET_TOOL_PREFERENCES } from 'modules/Apollo/queries';

export const { Provider: ToolPreferencesQueryProvider, useQuery: useToolPreferencesQuery } =
  createContextedQuery<GetToolPreferencesQuery, GetToolPreferencesQueryVariables>(
    GET_TOOL_PREFERENCES,
    {
      name: 'ToolPreferencesQuery',
    }
  );
